import pkg from '../../package.json';
import { CHANGELOG, type Release } from './changelog.js';

// `package.json` is the source of truth for the currently-shipped
// version string. The matching `Release` entry in CHANGELOG carries the
// codename, ship date, and highlights — this module just joins them.
//
// `tsconfig.json` has resolveJsonModule enabled, which is what lets us
// import a typed `version` field straight out of package.json.

export const APP_VERSION: string = pkg.version;

export const CURRENT_RELEASE: Release | undefined = CHANGELOG.find(
  (r) => r.version === APP_VERSION
);

export const CURRENT_CODENAME: string = CURRENT_RELEASE?.codename ?? '';

/**
 * Display string for footers and HUDs: `v0.4.0 — Reefkeeper`. Falls back
 * to bare version if the changelog is missing an entry (the test suite
 * guards against that, but be defensive here).
 */
export function versionLabel(): string {
  return CURRENT_CODENAME
    ? `v${APP_VERSION} — ${CURRENT_CODENAME}`
    : `v${APP_VERSION}`;
}
